import { Component } from '@angular/core';

@Component({
	selector: 'app-form-text-field',
	templateUrl: './form-text-field.component.html'
})
export class FormTextFieldComponent {
	constructor() {}
}
